import { render, staticRenderFns } from "./AdminBookingCard.vue?vue&type=template&id=683e4e6e&scoped=true&lang=pug&"
import script from "./AdminBookingCard.vue?vue&type=script&lang=ts&"
export * from "./AdminBookingCard.vue?vue&type=script&lang=ts&"
import style0 from "./AdminBookingCard.vue?vue&type=style&index=0&id=683e4e6e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683e4e6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex,VLayout})
